import axios from 'axios';

import { env } from 'config';
import { UserRole } from 'enums';
import { PayoutRequisites } from 'types';

import { createCrudApi } from './crud.api';

const path = '/payout-requisites';
const url = `${env.apiUrl}${path}`;

const getAllForTraderAsRole =
  (role: UserRole) =>
  async (traderId: string): Promise<PayoutRequisites[]> =>
    (await axios.get(`${url}/${role}/trader/${traderId}`)).data;

const create = async (
  requisites: Partial<PayoutRequisites>,
): Promise<PayoutRequisites> => (await axios.post(url, requisites)).data;

const update = async ({
  id,
  requisites,
}: {
  id: string;
  requisites: Partial<PayoutRequisites>;
}): Promise<PayoutRequisites> =>
  (await axios.patch(`${url}/${id}`, requisites)).data;

const updateStatus = async ({
  id,
  data,
}: {
  id: string;
  data: Pick<PayoutRequisites, 'status'>;
}): Promise<PayoutRequisites> =>
  (await axios.patch(`${url}/${id}/status`, data)).data;

const block = async (params: {
  id: string;
  blockedMessage: string;
}): Promise<PayoutRequisites> =>
  (
    await axios.patch(`${url}/${params.id}/block`, {
      blockedMessage: params.blockedMessage,
    })
  ).data;

const unblock = async (id: string): Promise<PayoutRequisites> =>
  (await axios.patch(`${url}/${id}/unblock`)).data;

const findOne = async (id: string): Promise<PayoutRequisites> =>
  (await axios.get(`${url}/${id}`)).data;

const remove = async (id: string): Promise<PayoutRequisites> =>
  (await axios.delete(`${url}/${id}`)).data;

const crudApi = createCrudApi<PayoutRequisites>(path);

export const payoutRequisitesApi = {
  ...crudApi,
  getAllForTraderAsRole,
  create,
  update,
  findOne,
  remove,
  updateStatus,
  block,
  unblock,
};
